var paragraph_default = {
  "fontElementMap": "x2YnE",
  "elementSpacing": "ll-Op",
  "text": "_1Lg1W ll-Op",
  "child": "-Q2Ax"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
